import { AiOutlineUser } from "react-icons/ai";
import { auth } from '../../Lib/Firebase/Firebase';
import FireLoginStatus from '../../Lib/Firebase/FireLoginStatus';
import { Link } from 'react-router-dom';
import "./NavUserIcon.css"
const NavUserIcon = () => {


  require("dotenv").config();

  let [user]=FireLoginStatus();

 

  let ADMIN_USER

  if(user){
    ADMIN_USER=user.uid
  }else{
    ADMIN_USER=""
  }

  return ( 

    <div className="header__Dropdown">
      <div 
      style={user?{border:"thin solid lime"}:{border:"thin solid black"}}
      className="header__profileImg">
      <AiOutlineUser/>
      {/* <img src={dan} alt="" srcset="" height="50px" /> */}
      </div>
        <ul style={{right: "0"}}
         className="header__Dropdown__UList" >
          
          
          <li data-testid="signUpbutton"
           style={!user?{display:"block"}:{display:"none"}}
          className="header__Dropdown__UList-li">
            <Link to="/SignUp" >
              Sign up
            </Link></li>

          <li data-testid="signOutButton"
           style={user?{display:"block"}:{display:"none"}}
          className="header__Dropdown__UList-li"
          onClick={()=>auth.signOut()}>
            Sign Out
          </li>

          <li data-testid="signInButton"
           className="header__Dropdown__UList-li"
           style={!user?{display:"block"}:{display:"none"}}>
             <Link to="/SignIn">Sign In</Link></li>

          {

          `${process.env.REACT_APP_ADMIN_UID}`===ADMIN_USER ||`${process.env.REACT_APP_ADMIN_UID2}`===ADMIN_USER ||
          `${process.env.REACT_APP_ADMIN_UID3}`===ADMIN_USER||
          `${process.env.REACT_APP_ADMIN_UID4}`===ADMIN_USER?

          <li data-testid="SettingsButton"
          className="header__Dropdown__UList-li">
            <Link to="/Setting">Settings</Link></li>
          :<></>
          }

        </ul>
    </div>

   );
}
 
export default NavUserIcon;